const priceToVariantMap = {
    25: 51109960909093,
    100: 51109550063909,
    200: 51109550096677,
    300: 51109550129445,
    350: 51109550162213,
    400: 51094643835173,
    450: 51094643802405,
    500: 51094643769637,
    525: 51094643736869,
    550: 51094643704101,
    575: 51094643671333,
    600: 51094643638565,
    625: 51109550194981,
    650: 51094643605797,
    700: 51094643573029,
    750: 51094643540261,
    775: 51109550227749,
    800: 51094643507493,
    850: 51094643474725,
    900: 51094643441957,
    950: 51094643409189,
    1000: 51109550260517,
    1050: 51109550293285,
    1075: 51094643376421,
    1100: 51109550326053,
    1150: 51109957108005,
    1175: 51109957140773,
    1200: 51109550358821,
    1250: 51109550391589,
    1275: 51109550424357,
    1300: 51109550457125,
    1350: 51109550489893,
    1400: 51109550522661,
    1450: 51109550555429,
    1500: 51109550588197,
    1550: 51109550620965,
    1600: 51109550653733,
    1650: 51109550686501,
    1700: 51109550719269,
    1750: 51109550752037,
    1800: 51109550784805,
    1850: 51109550817573,
    1900: 51109550850341,
};

const DELIVERY_FEE_PRODUCT_ID = '10053618696485';